import * as React from 'react';
import { TProductSelectableOption } from './ProductSelectableOption.types';
import './ProductSelectableOption.styled.scss';

export const ProductSelectableOption: TProductSelectableOption = ({
  label,
  isSelected,
  onChange,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange()}
      className={`product-selectable-option ${
        isSelected ? 'product-selectable-option--selected' : ''
      }`}
    >
      <p className="body2">{label}</p>
    </button>
  );
};
